
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ServiceStatus} from '../entity/ServiceStatus';
import {FieldModelServiceStatus} from '../entity/ServiceStatus';
import {ServiceStatusDetail} from './ServiceStatusDetail';
import {FieldModelServiceStatusDetail} from './ServiceStatusDetail';

/**
 * ServiceStatusUpdateNotify struct
 */
class ServiceStatusUpdateNotify {
  /**
   * Initialize struct
   * @param {!ServiceStatus=} status
   * @param {!Set=} details
   * @constructor
   */
  constructor (status = new ServiceStatus(), details = new Set()) {
    this.Status = status
    this.Details = details
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ServiceStatusUpdateNotify}
   * @param {!ServiceStatusUpdateNotify} other Other struct
   * @returns {!ServiceStatusUpdateNotify} This struct
   */
  copy (other) {
    if (other.Status != null) {
      this.Status = ServiceStatus.fromObject(other.Status)
    } else {
      this.Status = null
    }
    if (other.Details != null) {
      this.Details = new Set()
      for (let item of other.Details) {
        if (item != null) {
          let tempItem
          tempItem = ServiceStatusDetail.fromObject(item)
          this.Details.add(tempItem)
        } else {
          this.Details.add(null)
        }
      }
    } else {
      this.Details = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ServiceStatusUpdateNotify}
   * @returns {!ServiceStatusUpdateNotify} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ServiceStatusUpdateNotifyModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ServiceStatusUpdateNotifyModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ServiceStatusUpdateNotify}
   * @param {!ServiceStatusUpdateNotify} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ServiceStatusUpdateNotify)) {
      throw new TypeError('Instance of ServiceStatusUpdateNotify is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ServiceStatusUpdateNotify}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      Status: ((this.Status != null) ? this.Status : null),
      Details: ((this.Details != null) ? Array.from(this.Details, item => ((item != null) ? item : null)) : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ServiceStatusUpdateNotify.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ServiceStatusUpdateNotify} other Object value
   * @returns {!ServiceStatusUpdateNotify} Created struct
   */
  static fromObject (other) {
    return new ServiceStatusUpdateNotify().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ServiceStatusUpdateNotify}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ServiceStatusUpdateNotify.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ServiceStatusUpdateNotify}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 12005
  }
}

export { ServiceStatusUpdateNotify };

/**
 * Fast Binary Encoding ServiceStatusUpdateNotify field model
 */
class FieldModelServiceStatusUpdateNotify extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.Status = new FieldModelServiceStatus(buffer, 4 + 4)
    this.Details = new fbe.FieldModelSet(new FieldModelServiceStatusDetail(buffer, this.Status.fbeOffset + this.Status.fbeSize), buffer, this.Status.fbeOffset + this.Status.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.Status.fbeSize + this.Details.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.Status.fbeExtra + this.Details.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelServiceStatusUpdateNotify.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 12005
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Status.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Status.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Details.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Details.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Details.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!ServiceStatusUpdateNotify} fbeValue Default value, defaults is new ServiceStatusUpdateNotify()
   * @returns {!ServiceStatusUpdateNotify} ServiceStatusUpdateNotify value
   */
  get (fbeValue = new ServiceStatusUpdateNotify()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!ServiceStatusUpdateNotify} fbeValue ServiceStatusUpdateNotify value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.Status.fbeSize) <= fbeStructSize) {
      fbeValue.Status = this.Status.get()
    } else {
      fbeValue.Status = new ServiceStatus()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Status.fbeSize

    if ((fbeCurrentSize + this.Details.fbeSize) <= fbeStructSize) {
      this.Details.get(fbeValue.Details)
    } else {
      fbeValue.Details.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Details.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {!ServiceStatusUpdateNotify} fbeValue ServiceStatusUpdateNotify value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelServiceStatusUpdateNotify}
   * @param {ServiceStatusUpdateNotify} fbeValue ServiceStatusUpdateNotify value
   */
  setFields (fbeValue) {
    this.Status.set(fbeValue.Status)
    this.Details.set(fbeValue.Details)
  }
}

export { FieldModelServiceStatusUpdateNotify };

/**
 * Fast Binary Encoding ServiceStatusUpdateNotify model
 */
class ServiceStatusUpdateNotifyModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelServiceStatusUpdateNotify(this.buffer, 4)
  }

  /**
   * Get the ServiceStatusUpdateNotify model
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!FieldModelServiceStatusUpdateNotify} model ServiceStatusUpdateNotify model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ServiceStatusUpdateNotifyModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelServiceStatusUpdateNotify.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ServiceStatusUpdateNotifyModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ServiceStatusUpdateNotifyModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ServiceStatusUpdateNotifyModel}
   * @param {!ServiceStatusUpdateNotify} value ServiceStatusUpdateNotify value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ServiceStatusUpdateNotifyModel}
   * @param {!ServiceStatusUpdateNotify} value ServiceStatusUpdateNotify value, defaults is new ServiceStatusUpdateNotify()
   * @return {!object} Deserialized ServiceStatusUpdateNotify value and its size
   */
  deserialize (value = new ServiceStatusUpdateNotify()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ServiceStatusUpdateNotify(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ServiceStatusUpdateNotify(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ServiceStatusUpdateNotifyModel}
   * @param {!number} prev Previous ServiceStatusUpdateNotify model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ServiceStatusUpdateNotifyModel };
